namespace GeniuzPOS.Product {
    export interface QryMasterForm {
        SkuCode: Serenity.LookupEditor;
        SkuDesc: Serenity.StringEditor;
        SkuEnDesc: Serenity.StringEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        StyleId: Serenity.LookupEditor;
        ColorId: Serenity.LookupEditor;
        SizeId: Serenity.LookupEditor;
        TasteId: Serenity.LookupEditor;
        MatTypeId: Serenity.LookupEditor;
        SupplierId: Serenity.LookupEditor;
        VatType: Serenity.LookupEditor;
        ConsignFg: Serenity.EnumEditor;
        StockFg: Serenity.EnumEditor;
    }

    export class QryMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Product.QryMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QryMasterForm.init)  {
                QryMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;

                Q.initFormType(QryMasterForm, [
                    'SkuCode', w0,
                    'SkuDesc', w1,
                    'SkuEnDesc', w1,
                    'CatCode', w0,
                    'SubCat1Code', w0,
                    'SubCat2Code', w0,
                    'BrandCode', w0,
                    'StyleId', w0,
                    'ColorId', w0,
                    'SizeId', w0,
                    'TasteId', w0,
                    'MatTypeId', w0,
                    'SupplierId', w0,
                    'VatType', w0,
                    'ConsignFg', w2,
                    'StockFg', w2
                ]);
            }
        }
    }
}
